import { render, staticRenderFns } from "./aboutYC.vue?vue&type=template&id=0f670d48&scoped=true"
import script from "./aboutYC.vue?vue&type=script&lang=js"
export * from "./aboutYC.vue?vue&type=script&lang=js"
import style0 from "./aboutYC.vue?vue&type=style&index=0&id=0f670d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f670d48",
  null
  
)

export default component.exports